<template>
  <div class="row">
    <notifications></notifications>
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.voucher')"
        :col="3"
      >
        <div class="row d-flex justify-content-between">
          <div class="ml-4">
            <button
              class="btn btn-success"
              @click="neuerVoucher"
              v-if="editable || berechtigungen.m_notizen.create"
            >
              <font-awesome-icon icon="fa-regular fa-plus" class="mr-2" />
              <span>{{ $t("global.new") }}</span>
            </button>
          </div>
          <div class="mr-4">
            <button
              class="btn btn-danger"
              @click="oeffneLoeschenModal"
              :disabled="isBusy || selectedIds.length === 0"
            >
              <font-awesome-icon icon="fa-duotone fa-trash" class="mr-2" />
              <span>{{ $t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              style="max-height: 300px"
              :items="voucherliste"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :busy="isBusy"
              show-empty
              sort-icon-left
              responsive
              selectable
              select-mode="range"
              @row-dblclicked="voucherOeffnen"
              small
              thead-tr-class="pointer"
            >
              <template v-slot:head(selected)="row">
                <b-form-checkbox
                  v-model="row.selected"
                  @input="selectAllRows(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @input="onRowSelected(row)"
                ></b-form-checkbox>
              </template>

              <template #cell(gueltig_bis)="row">
                {{ formatDate(row.item.gueltig_bis) }}
              </template>

              <template #cell(details)="row">
                <b-button
                  @click="row.toggleDetails"
                  class="m-0"
                  variant="outline-primary"
                  size="sm"
                >
                  <font-awesome-icon
                    :icon="
                      row.detailsShowing ? 'fa-chevron-up' : 'fa-chevron-down'
                    "
                  />
                </b-button>
              </template>
              <template #row-details="row">
                <div class="mx-2 my-1">
                  <div v-html="row.item.beschreibung"></div>
                  <div v-if="row.item.beschreibung == ''">
                    {{ $t("global.novouchersdescription") }}
                  </div>
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div
                  v-if="voucherLadeFehler"
                  class="text-center text-danger my-2"
                >
                  <strong>{{ $t("global.errorwhileloading") }}</strong>
                </div>
                <div
                  v-if="!voucherLadeFehler"
                  class="text-center text-primary my-2"
                >
                  <strong>{{ $t("global.nodataavailable") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <voucher-modal
      @voucherCreated="voucherErstellt"
      @voucherChanged="voucherGeaendert"
      @voucherDeleted="voucherDeleted"
      :isBusy="isBusy"
      :firma="firma"
      :statusOptions="auswahlwerteFirmaAgriviva.voucherStatus"
    />

    <loeschen-modal id="voucher-loeschen-modal" @confirmed="voucherLoeschen" />
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";
import VoucherModal from "@/newviva/components/Modale/VoucherModal";

import LoeschenModal from "@/components/Modals/LoeschenModal";
import reiter from "@/mixins/Reiter";
import { LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA } from "@/store/agriviva-firma/actions.type";

export default {
  name: "voucherliste",
  components: {
    ContainerHeadline,
    LoeschenModal,
    BSpinner,
    VoucherModal,
  },
  mixins: [reiter],
  props: {
    firma: {
      type: Object,
      required: false,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      page: 0,
      anzahlProPage: 100,
      sortBy: "gueltigBis",
      sortDesc: false,
      isBusy: false,
      ladeFehler: false,
      voucherliste: [],
      selected: [],
      selectedIds: [],
      voucherLadeFehler: false,
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "gueltig_bis",
          sortable: true,
          label: `${this.$t("global.validuntil")} (${this.$t("global.date")})`,
        },
        {
          key: "token",
          sortable: true,
          label: this.$t("global.token"),
        },
        {
          key: "verfuegbare_codes",
          sortable: true,
          label: this.$t("global.availableCodes"),
        },
        {
          key: "verwendete_codes",
          sortable: true,
          label: this.$t("global.usedCodes"),
        },
        {
          key: "status_bezeichnung",
          sortable: true,
          label: this.$t("global.status"),
        },
      ];
    },

    auswahlwerteFirmaAgriviva: {
      get() {
        return this.$store.state.agrivivaFirma;
      },
    },

    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      if (this.suche) params.suche = this.suche;

      return params;
    },
  },
  watch: {
    shown(val) {
      if (val && this.voucherliste.length == 0) this.getVoucher();
    },
    firma() {
      if (this.shown && this.voucherliste.length == 0) this.getVoucher();
    }
  },
  mounted() {
    if (this.shown && this.voucherliste.length == 0) this.getVoucher();

    if (this.auswahlwerteFirmaAgriviva == null)
      this.$store.dispatch(`agrivivaFirma/${LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA}`);
  },
  created() {},

  methods: {
    formatDate(value) {
      if (value == null) return "";
      const d = new Date(Number(value)); // <-- Epoch millis
      if (Number.isNaN(d.getTime())) return String(value);
      return d.toLocaleDateString("de-CH");
    },

    getVoucher() {
      this.isBusy = true;

      let firma = this.firma ? this.firma.id : null;

      if (!firma) {
        this.voucherliste = [];
        this.isBusy = false;
        return;
      }

      AppApi.get("firma-voucher/", {
        params: {
          firmaId: firma,
        },
      })
        .then((response) => {
          this.voucherliste = response.data;
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    details(voucher) {
      this.$router.push({
        name: "voucher",
        params: { id: voucher.id, anzeige: 0 },
      });
    },

    neuerVoucher() {
      const payload = {
        neu: true,
        firmaId: this.firma?.id || null,
      };
      this.$bus.$emit("voucher-modal-show", payload);
    },

    voucherOeffnen(voucher) {
      this.$bus.$emit("voucher-modal-show", voucher);
    },

    voucherDeleted(voucher_id) {
      this.isBusy = true;

      AppApi.delete("firma-voucher/", {
        data: [voucher_id],
      })
        .then(() => {
          this.getVoucher();
          this.voucherLadeFehler = false;

          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.deleted"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.voucherLadeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    voucherErstellt(voucher) {
      this.isBusy = true;

      const json = {
        firmaId: this.firma?.id || null,
        token: voucher.token || null,
        gueltigBis: voucher.gueltigBis || null,
        kontigent: voucher.kontigent ?? null,
        statusId: voucher.status_id || null,
      };

      AppApi.post("firma-voucher/", json)
        .then(() => {
          this.getVoucher();
          this.voucherLadeFehler = false;

          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.savedsuccessfully"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.voucherLadeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    voucherGeaendert(voucher) {
      this.isBusy = true;

      const json = {
        id: voucher.id,
        gueltigBis: voucher.gueltigBis || null,
        kontigent: voucher.kontigent ?? null,
        statusId: voucher.status_id || null,
      };

      AppApi.put("firma-voucher/", json, { params: { id: voucher.id } })
        .then(() => {
          this.getVoucher();
          this.voucherLadeFehler = false;

          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.savedsuccessfully"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.voucherLadeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = true;
        });
      } else {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "voucher-loeschen-modal");
      else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.novoucherselected"),
        });
      }
    },

      voucherLoeschen() {
      this.isBusy = true;
      AppApi.delete("firma-voucher/", {
        data: this.selectedIds,
      })
        .then(() => {
          this.$emit("updateComponent");
          this.getVoucher();
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: `${this.selectedIds.length} ${this.$t(
              "global.vouchersdeleted"
            )}`,
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.voucherLadeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
      }
    },
  },
};
</script>
